import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';

export type MessageSeverity = 'error' | 'warn' | 'success' | 'info';

/**
 * Message contextuel (erreur de formulaire, confirmation, information).
 *
 * Usage : <idra-message severity="error">Identifiants invalides.</idra-message>
 */
@Component({
  selector: 'idra-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'alert',
    '[class.error]': "severity() === 'error'",
    '[class.warn]': "severity() === 'warn'",
    '[class.success]': "severity() === 'success'",
    '[class.info]': "severity() === 'info'",
  },
  styles: `
    :host {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 14px;
      border-radius: var(--idra-radius-sm);
      font-size: 13.5px;
      font-weight: 600;
    }

    :host(.error) {
      background: var(--idra-danger-bg);
      color: var(--idra-danger);
    }
    :host(.warn) {
      background: var(--idra-warning-bg);
      color: var(--idra-warning);
    }
    :host(.success) {
      background: var(--idra-success-bg);
      color: var(--idra-primary-soft-text);
    }
    :host(.info) {
      background: var(--idra-info-bg);
      color: var(--idra-info);
    }
  `,
  template: `
    <i [class]="iconClass()" aria-hidden="true"></i>
    <ng-content />
  `,
})
export class IdraMessage {
  readonly severity = input<MessageSeverity>('info');

  protected readonly iconClass = computed(() => {
    switch (this.severity()) {
      case 'error':
        return 'pi pi-times-circle';
      case 'warn':
        return 'pi pi-exclamation-triangle';
      case 'success':
        return 'pi pi-check-circle';
      default:
        return 'pi pi-info-circle';
    }
  });
}
